import React from "react";
import CurrencyElement from "@appComponents/CurrencyElement/CurrencyElement";
import moment from "moment";
import { Checkbox } from "antd";
import { FormikProps } from "formik";
import Big from "big.js";
import { StakingResponse } from "@services/Funds.service";
import { TransactionStatusBadge } from "./parts/TransactionStatusBadge";

import * as style from "../StepsStyle.module.scss"

const big = Big();

export const transactionsColumns = ({
  formik,
  isCheckedAll,
  handleCheckAllTransactions,
}: {
  formik: FormikProps<any>;
  isCheckedAll: boolean;
  handleCheckAllTransactions: () => void;
}) => [
  {
    title: () => {
      return (
        <div className={style.transactionsCheckboxWrapper}>
          <Checkbox
            indeterminate={
              !!formik.values.transactionIds.length && !isCheckedAll
            }
            checked={isCheckedAll}
            onChange={handleCheckAllTransactions}
          />
        </div>
      );
    },
    dataIndex: "status",
    render: (_: string, record: StakingResponse) => {
      const transactionIds = formik.values.transactionIds;
      const isChecked = transactionIds.includes(record.id);

      return (
        <div className={style.transactionsCheckboxWrapper}>
          <Checkbox checked={isChecked} />
        </div>
      );
    },
    width: 50,
  },
  {
    title: "AMOUNT",
    dataIndex: "amount",
    width: "50%",
    sorter: (a: StakingResponse, b: StakingResponse) =>
      big(a.amount ?? 0).gt(b.amount ?? 0) ? 0 : 1,
    render: (val: number) => (
      <CurrencyElement value={val} currency={"staked_eth"} />
    ),
  },
  {
    title: "STAKING DATE",
    dataIndex: "created_at",
    width: "30%",
    sorter: (a: StakingResponse, b: StakingResponse) =>
      big(new Date(a.created_at).getTime() ?? 0).gt(
        new Date(b.created_at).getTime() ?? 0
      )
        ? 0
        : 1,
    render: (text: string) => moment(text).format("DD MMM, YYYY"),
  },
  {
    title: "",
    dataIndex: "status",
    render: (text: string) => <TransactionStatusBadge status={text} />,
  },
];
